export default __webpack_public_path__ + "static/media/markets.d91e5629.svg";